import {Injectable} from '@angular/core';
import {GatewayRpcService, Namespace, Version} from "../gateway";
import {Notice, NotificationActions} from './'

@Injectable({
  providedIn: 'root'
})
export class NotificationRpcService {

  constructor(private rpc: GatewayRpcService) {
  }

  async get() {
    try {
      const req = await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Notification,
          action: NotificationActions.Get,
          data: {}
        });
        return req.notices.map( (n:Notice) => {
          return{...n, data: JSON.parse(n.data ?? "{}")}
        });
    } catch (e) {
      return e;
    }
  }
  async add(notice:Notice) {
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Notification,
          action: NotificationActions.Add,
          data: notice
        });
    } catch (e) {
      return e;
    }
  }

  async read(notice:Notice):Promise<Notice[]> {
    const _notice = structuredClone(notice)
    _notice.data = "";
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Notification,
          action: NotificationActions.Read,
          data: _notice
        });
    } catch (e:any) {
      return e;
    }
  }

  async remove(notice:Notice) {
    notice.data = "";
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Notification,
          action: NotificationActions.Remove,
          data: notice
        });
    } catch (e) {
      return e;
    }
  }

  async clear() {
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Notification,
          action: NotificationActions.Clear,
          data: {}
        });
    } catch (e) {
      return e;
    }
  }

}

